// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NEET Preparation Page Styles */
.neet-page {
  min-height: 100vh;
}

.course-hero {
  background: linear-gradient(135deg, var(--color-primary) 0%, #4a1548 100%);
  color: white;
  padding: 6rem 0 4rem;
  text-align: center;
}

.hero-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
}

.course-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  font-size: 0.95rem;
  font-weight: 500;
  margin-bottom: 1rem;
  backdrop-filter: blur(10px);
}

.course-title {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1rem;
}

.course-subtitle {
  font-size: 1.25rem;
  line-height: 1.6;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .course-hero {
    padding: 4rem 0 3rem;
  }
  
  .course-title {
    font-size: 2rem;
  }
  
  .course-subtitle {
    font-size: 1.125rem;
  }
}

.jp-cta {
  margin-top: 34px;
  border-radius: 16px;
  padding: 22px 24px;
  color: #ffffff;
  background: #400C4D;
  box-shadow: 0 26px 60px rgba(64, 12, 77, 0.45);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.jp-page.jp-page--neet .jp-cta {
  background: #400C4D;
  box-shadow: 0 26px 60px rgba(64, 12, 77, 0.45);
}

.jp-cta__title {
  margin: 0 0 6px;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  letter-spacing: 0.01em;
  font-size: clamp(2rem, 2.6vw, 2.5rem);
  color: #ffffff;
}

.jp-cta__text {
  margin: 0;
  color: rgba(255, 255, 255, 0.95);
  font-size: 1.05rem;
  max-width: 420px;
  line-height: 1.45;
}

.jp-cta__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* ================================
   JP HERO LAYOUT FIX (NEET = image RIGHT)
   ================================ */

.jp-page.jp-page--neet .jp-hero {
  position: relative;
  overflow: hidden;
  border-radius: 22px;
  min-height: 360px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  background: #400C4D;
  box-shadow: 0 26px 60px rgba(64, 12, 77, 0.35);
}

.jp-page.jp-page--neet .jp-hero__image {
  flex: 0 0 58%;
  background-size: cover;
  background-position: center;
  border-radius: 18px;
  margin: 18px 18px 18px 0;
  order: 2;
  background-color: #ffffff;
}

.jp-page.jp-page--neet .jp-hero__content {
  flex: 1;
  order: 1;
  padding: 42px 10px 42px 42px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
  color: #fff;
}

@media (max-width: 900px) {
  .jp-page.jp-page--neet .jp-hero {
    flex-direction: column;
    min-height: auto;
  }

  .jp-page.jp-page--neet .jp-hero__image {
    flex: none;
    height: 260px;
    margin: 16px;
  }

  .jp-page.jp-page--neet .jp-hero__content {
    padding: 10px 18px 22px;
  }

  .jp-page.jp-page--neet .jp-hero__image,
  .jp-page.jp-page--neet .jp-hero__content {
    order: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Courses/neet-preparation.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,iBAAiB;AACnB;;AAEA;EACE,0EAA0E;EAC1E,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;qCAEqC;;AAErC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;EACxB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,YAAY;EACd;AACF","sourcesContent":["/* NEET Preparation Page Styles */\n.neet-page {\n  min-height: 100vh;\n}\n\n.course-hero {\n  background: linear-gradient(135deg, var(--color-primary) 0%, #4a1548 100%);\n  color: white;\n  padding: 6rem 0 4rem;\n  text-align: center;\n}\n\n.hero-container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.course-badge {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 0.5rem 1rem;\n  border-radius: 2rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  margin-bottom: 1rem;\n  backdrop-filter: blur(10px);\n}\n\n.course-title {\n  font-size: 3rem;\n  font-weight: 800;\n  line-height: 1.2;\n  margin-bottom: 1rem;\n}\n\n.course-subtitle {\n  font-size: 1.25rem;\n  line-height: 1.6;\n  opacity: 0.9;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n@media (max-width: 768px) {\n  .course-hero {\n    padding: 4rem 0 3rem;\n  }\n  \n  .course-title {\n    font-size: 2rem;\n  }\n  \n  .course-subtitle {\n    font-size: 1.125rem;\n  }\n}\n\n.jp-cta {\n  margin-top: 34px;\n  border-radius: 16px;\n  padding: 22px 24px;\n  color: #ffffff;\n  background: #400C4D;\n  box-shadow: 0 26px 60px rgba(64, 12, 77, 0.45);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.jp-page.jp-page--neet .jp-cta {\n  background: #400C4D;\n  box-shadow: 0 26px 60px rgba(64, 12, 77, 0.45);\n}\n\n.jp-cta__title {\n  margin: 0 0 6px;\n  font-family: Lexend, Inter, system-ui, sans-serif;\n  font-weight: 900;\n  letter-spacing: 0.01em;\n  font-size: clamp(2rem, 2.6vw, 2.5rem);\n  color: #ffffff;\n}\n\n.jp-cta__text {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 1.05rem;\n  max-width: 420px;\n  line-height: 1.45;\n}\n\n.jp-cta__actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n/* ================================\n   JP HERO LAYOUT FIX (NEET = image RIGHT)\n   ================================ */\n\n.jp-page.jp-page--neet .jp-hero {\n  position: relative;\n  overflow: hidden;\n  border-radius: 22px;\n  min-height: 360px;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  background: #400C4D;\n  box-shadow: 0 26px 60px rgba(64, 12, 77, 0.35);\n}\n\n.jp-page.jp-page--neet .jp-hero__image {\n  flex: 0 0 58%;\n  background-size: cover;\n  background-position: center;\n  border-radius: 18px;\n  margin: 18px 18px 18px 0;\n  order: 2;\n  background-color: #ffffff;\n}\n\n.jp-page.jp-page--neet .jp-hero__content {\n  flex: 1;\n  order: 1;\n  padding: 42px 10px 42px 42px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 14px;\n  color: #fff;\n}\n\n@media (max-width: 900px) {\n  .jp-page.jp-page--neet .jp-hero {\n    flex-direction: column;\n    min-height: auto;\n  }\n\n  .jp-page.jp-page--neet .jp-hero__image {\n    flex: none;\n    height: 260px;\n    margin: 16px;\n  }\n\n  .jp-page.jp-page--neet .jp-hero__content {\n    padding: 10px 18px 22px;\n  }\n\n  .jp-page.jp-page--neet .jp-hero__image,\n  .jp-page.jp-page--neet .jp-hero__content {\n    order: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
